module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono@3x-0b9196e22df6d9e1c3ea8415f546e6c5.webp";